export const BLUE = "#5FB955";
export const RED = "#1967D2";
